import { createFileRoute } from "@tanstack/react-router";
import { RelatorioLancamentos } from "pages/relatorios/pages/lancamentos";

export const Route = createFileRoute("/a/relatorios/lancamentos")({
	component: RelatorioLancamentos,
});
